export const variantsLabel = {
  visible: {
    opacity: 1,
    translateY: 0,
    transition: { duration: 0.4 },
  },
  hidden: { opacity: 0, translateY: 30 },
}

export const variantsHeadline = {
  visible: {
    opacity: 1,
    translateY: 0,
    transition: { duration: 0.4, delay: 0.15 },
  },
  hidden: { opacity: 0, translateY: 30 },
}

export const variantsCards = {
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, delay: i * 0.1 },
  }),
  hidden: (i: number) => ({
    opacity: 0,
    y: 20,
    transition: { duration: 0.3, delay: i * 0.1 },
  }),
}

export const variantsModal = {
  visible: {
    opacity: 1,
    transition: { duration: 0.1 },
  },
  hidden: {
    opacity: 0,

    transition: { duration: 0.1 },
  },
}
